import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors, withXhr } from "@angular/common/http";
import { en_US, provideNzI18n } from "ng-zorro-antd/i18n";
import { createErrorHandler, TraceService } from "@sentry/angular";
import { routes } from "./app.routes";
import { credentialsInterceptor } from "./libs/interceptors/credentials.interceptor";
import { authErrorInterceptor } from "./libs/interceptors/auth-error.interceptor";
import { localeInterceptor } from "./libs/interceptors/locale.interceptor";

import {
  BgColorsOutline,
  CheckCircleOutline,
  EditOutline,
  HomeOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  RiseOutline,
  TeamOutline,
  UserOutline,
  DashboardOutline,
  BankOutline,
  PlusOutline,
  SettingOutline,
  ArrowLeftOutline,
  EnvironmentOutline,
  SolutionOutline,
  ApartmentOutline,
  UsergroupAddOutline,
  UserAddOutline,
  LogoutOutline,
  MessageOutline,
  BellOutline,
  SendOutline,
  ReloadOutline,
  QrcodeOutline,
  CloseCircleOutline,
  FileProtectOutline,
  FieldTimeOutline,
  SafetyCertificateOutline,
  FileTextOutline,
  DownloadOutline,
  AuditOutline,
  PlusCircleOutline,
  FilePdfOutline,
  DeleteOutline,
  ThunderboltOutline,
  ScheduleOutline,
  EyeOutline,
  EyeInvisibleOutline
} from "@ant-design/icons-angular/icons";
import { IconDefinition } from "@ant-design/icons-angular";
import { provideNzIcons } from "ng-zorro-antd/icon";
import { provideNzDateFnsAdapter } from "ng-zorro-antd/core/time";

const icons: IconDefinition[] = [
  HomeOutline,
  UserOutline,
  EditOutline,
  BgColorsOutline,
  TeamOutline,
  CheckCircleOutline,
  RiseOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  BankOutline,
  PlusOutline,
  SettingOutline,
  ArrowLeftOutline,
  EnvironmentOutline,
  SolutionOutline,
  ApartmentOutline,
  UsergroupAddOutline,
  UserAddOutline,
  LogoutOutline,
  MessageOutline,
  BellOutline,
  SendOutline,
  ReloadOutline,
  QrcodeOutline,
  CloseCircleOutline,
  FileProtectOutline,
  FieldTimeOutline,
  SafetyCertificateOutline,
  FileTextOutline,
  DownloadOutline,
  AuditOutline,
  PlusOutline,
  PlusCircleOutline,
  FilePdfOutline,
  DeleteOutline,
  ThunderboltOutline,
  ScheduleOutline,
  EyeOutline,
  EyeInvisibleOutline
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideNzDateFnsAdapter(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withInterceptors([credentialsInterceptor, localeInterceptor, authErrorInterceptor])
    ),
    provideNzI18n(en_US),
    provideNzIcons(icons),
    { provide: ErrorHandler, useValue: createErrorHandler() },
    TraceService,
    provideAppInitializer(() => {
      inject(TraceService);
    })
  ]
};
